import axios from 'axios';
import { getUserData } from './storageService';

const API_URL = process.env.REACT_APP_API_URL
  ? `${process.env.REACT_APP_API_URL}/late-incident`
  : 'https://backend-c-0mxm.onrender.com/api/late-incident';

const api = axios.create({ baseURL: API_URL });

api.interceptors.request.use((config) => {
  const user = getUserData();
  if (user) {
    config.headers.Authorization = `Bearer ${user.userId || user.token}`;
  }
  return config;
});

const handleError = (error) => {
  if (error.response) {
    return { message: error.response.data.message || 'Có lỗi xảy ra', status: error.response.status };
  }
  if (error.request) {
    return { message: 'Không thể kết nối đến server', status: 0 };
  }
  return { message: 'Có lỗi xảy ra', status: 0 };
};

// params: { userId, monthKey } hoặc { userId, from, to }
export const getLateIncidents = async (params = {}) => {
  try {
    const response = await api.get('/', { params });
    return { success: true, data: response.data.data };
  } catch (error) {
    return { success: false, error: handleError(error) };
  }
};

// Xem trước tiền phạt của kỳ: số lần trễ → hệ số → thành tiền
export const getLateSummary = async (userId, params = {}) => {
  try {
    const response = await api.get(`/summary/${userId}`, { params });
    return { success: true, data: response.data.data };
  } catch (error) {
    return { success: false, error: handleError(error) };
  }
};

export const createLateIncident = async (payload) => {
  try {
    const response = await api.post('/', payload);
    return { success: true, data: response.data.data, message: response.data.message };
  } catch (error) {
    return { success: false, error: handleError(error) };
  }
};

export const updateLateIncident = async (id, payload) => {
  try {
    const response = await api.put(`/${id}`, payload);
    return { success: true, data: response.data.data, message: response.data.message };
  } catch (error) {
    return { success: false, error: handleError(error) };
  }
};

export const deleteLateIncident = async (id) => {
  try {
    const response = await api.delete(`/${id}`);
    return { success: true, message: response.data.message };
  } catch (error) {
    return { success: false, error: handleError(error) };
  }
};
